/* eslint-disable no-unused-vars */
import {
  AccessTime,
  AddCircleOutlineRounded,
  CalendarMonthRounded,
  ChevronRightRounded,
  DeleteOutlineRounded,
  FmdGoodOutlined,
  InfoOutlined,
} from '@mui/icons-material';
import {
  Box, Button, CircularProgress, Container, Divider, Drawer, IconButton, MenuItem, TextField,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Link, useLocation, useNavigate,
} from 'react-router-dom';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import { getAddress } from '../../../../Redux/Models/address';
import { getUserItems } from '../../../../Redux/Models/box';
import { createRequestOut } from '../../../../Redux/Models/request';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';
import { AddressBoxes } from '../AddressList/AddressList';
import { getRequestOutMethod } from '../../../../Redux/Models/master';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import { formatNumToCurrency, onlyNumbers } from '../../../../Utils/helpers';

export default function Dev({
  classes, error, message, isLoading, requestOutSuccess,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = getUserData();
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);
  // const { itemId } = useParams();
  const domLocation = useLocation();
  const { address, box, master } = useSelector((state) => state);
  const { deliveryLoading, delivery } = master;
  const [items, setItems] = useState([]);
  const { t } = useTranslation();

  const headerTooltipMessage = t('reqOut.tip');
  const reminders = [
    {
      minutes: '30',
      desc: t('reqOut.remind1'),
    },
    {
      minutes: '60',
      desc: t('reqOut.remind2'),
    },
    {
      minutes: '120',
      desc: t('reqOut.remind3'),
    },
    {
      minutes: '180',
      desc: t('reqOut.remind4'),
    },
    {
      minutes: '360',
      desc: t('reqOut.remind5'),
    },
  ];

  const { openAlert } = useContext(AlertContext);
  const [submitted, setSubmitted] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [openChangeAddress, setOpenChangeAddress] = useState(false);
  const [openAddItems, setOpenAddItems] = useState(false);
  const [openBookPickup, setOpenBookPickup] = useState(false);
  const [openSelectDelivery, setOpenSelectDelivery] = useState(false);
  const [openTooltipBookPickup, setOpenTooltipBookPickup] = useState(false);
  const [book, setBook] = useState({
    pickup_date: moment().add(1, 'days').toDate(),
    reminder: null,
  });
  const [isBox, setIsBox] = useState(false);

  const [selectedDelivery, setDelivery] = useState({});

  const [fields, setFields] = useState({
    pickup_address: {},
    pickup_date: null,
    delivery: {},
    pickup_notes: '',
    pickup_amount: 0,
  });

  const handleSetBookPickup = () => {
    setFields({ ...fields, ...book });
    setOpenBookPickup(false);
  };

  const handleSetDelivery = () => {
    setFields({ ...fields, delivery: selectedDelivery });
    setOpenSelectDelivery(false);
  };

  const itemsIds = isBox ? [] : items.map((item) => item.item?.id);

  useEffect(() => {
    if (address.data.length && !fields.pickup_address?.id) {
      const selectedAddress = address.data.filter((addr) => addr.is_default)[0];
      setFields({
        ...fields,
        pickup_address: selectedAddress,
      });
    }
  }, [address]);

  useEffect(() => {
    dispatch(getAddress(userData.id));
    dispatch(getUserItems(userData.id));
    dispatch(getRequestOutMethod());
  }, []);

  useEffect(() => {
    if (domLocation.state) {
      if (domLocation.state.type === 'Item') {
        if (!itemsIds.includes(domLocation.state.item?.id)) {
          setItems([...items, domLocation.state]);
        }
      }

      if (domLocation.state.type === 'Box') {
        setItems([domLocation.state]);
        setIsBox(true);
        setFields({
          ...fields,
          pickup_amount: domLocation.state.box?.amount,
        });
      }
    }
  }, [domLocation.state]);

  const deleteItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const takeAddress = (add) => {
    setFields({ ...fields, pickup_address: add });
    setOpenChangeAddress(false);
  };

  const getReminderDesc = (mins) => {
    const selectedReminder = reminders.filter((reminder) => reminder.minutes === mins);
    if (selectedReminder.length) {
      return selectedReminder[0].desc;
    }
    return '';
  };

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const handleRequestOut = () => {
    if (!itemsIds.length && !isBox) {
      openAlert({
        title: 'Item can\'t be empty',
        message: 'Please add minimum 1 item or 1 box',
        severity: 'warning',
      });
      return;
    }
    if (!fields.delivery.id) {
      openAlert({
        message: 'Please choose delivery method',
        severity: 'warning',
      });
      return;
    }
    if (!fields.pickup_date) {
      openAlert({
        message: 'Please set pickup schedule',
        severity: 'warning',
      });
      return;
    }
    if (!fields.pickup_amount && isBox) {
      openAlert({
        title: 'Amount can\'t be 0',
        message: 'Please set request out items amount',
        severity: 'warning',
      });
      return;
    }

    const body = {
      items: itemsIds,
      owner: userData.id,
      owner_address: fields.pickup_address.id,
      pickup_address: fields.pickup_address.id,
      pickup_date: fields.pickup_date?.toISOString(),
      delivery_id: fields.delivery.id,
      pickup_notes: fields.pickup_notes,
      type: isBox ? 'Box' : 'Item',
    };

    if (isBox && items[0]) {
      body.pickup_amount = fields.pickup_amount;
      body.box = items[0].box?.id;
    }

    dispatch(createRequestOut(userData.id, body));
    setSubmitted(true);
  };

  useEffect(() => {
    if (requestOutSuccess && submitted) {
      openAlert({
        title: 'Request order placed',
        message: 'Your order will confirm soon, please wait!',
        severity: 'success',
      });
      navigate(ROUTES.home());
    }
  }, [requestOutSuccess, submitted]);

  const handleShowBackAlert = () => {
    openConfirmation({
      handleAgree: () => {
        closeConfirmation();
        navigate(ROUTES.myStorages());
      },
      title: 'Cancel progress?',
      desc: 'Your information progress will not be saved',
      confirmText: 'Confirm',
    });
  };

  const renderAddress = () => (
    <Box mt={1.5} p={1.5} border="1px solid #E5E5E5" borderRadius={1}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <div className="weight-700">{fields.pickup_address?.label}</div>
        <div className="weight-600 primary-green link" onClick={() => setOpenChangeAddress(true)}>Change</div>
      </Box>
      <Box mt={1}>
        <div className="s-12">{fields.pickup_address?.name}</div>
        <div className="s-12 mt-1">
          +
          {fields.pickup_address?.phone_number}
        </div>
      </Box>
      <Box mt={0.5} bgcolor="#F5F6F8" borderRadius={1} py={0.5} px={1} display="flex" alignItems="flex-start" gap={1}>
        <FmdGoodOutlined fontSize="small" />
        <div className="s-12">
          {fields.pickup_address.address}
          ,
          {' '}
          {fields.pickup_address.city}
          ,
          {' '}
          {fields.pickup_address.province}
          ,
          {' '}
          {fields.pickup_address.country}
          ,
          {' '}
          {fields.pickup_address.postal_code}
        </div>
      </Box>
    </Box>
  );

  const renderAllItems = (data) => data.filter((item) => item.type === 'Item' && !item.is_process && !item.item?.is_sale).map((item, index) => (
    <Box
      display="flex"
      gap={1.5}
      mt={1.5}
      key={index}
      py={1.5}
      px={1}
      borderRadius="10px"
      sx={{ cursor: 'pointer' }}
      onClick={() => {
        if (!itemsIds.includes(item.id)) {
          navigate(ROUTES.requestOut(), { state: item });
        } else {
          deleteItem(item.id);
        }
      }}
      border={itemsIds.includes(item.id) ? '1px solid #B4112E' : '1px solid #E5E5E5'}
    >
      <img width="80px" height="80px" className="rounded cover" src={item.item?.photo || item.box?.photo} alt={item.item?.name || item.box?.name} />
      <Box flex={1}>
        {item.type === 'Box'
          ? (
            <div className="weight-600">
              {item.box?.name || `Box ${item.box?.digital_box_id}`}
            </div>
          )
          : <div className="weight-600">{item.item?.name}</div>}
        {item.type === 'Box'
          ? (
            <Box>
              <Box>
                {item.box?.amount}
                {' '}
                {t('common.items')}
              </Box>
              <Box>
                {item.box?.dimension}
              </Box>
            </Box>
          ) : (
            <Box display="flex" className="s-10" color="#586479" gap={0.5} flexWrap="wrap" alignItems="center">
              <div>{item.category?.name || '-'}</div>
              <div>
                ・
                {item.condition?.name || '-'}
              </div>
              <div>
                ・
                {item.item?.volume || '0 mL'}
              </div>
            </Box>
          )}
      </Box>
    </Box>
  ));

  const renderSelectedItems = (data) => data.map((item, index) => (
    <Box display="flex" gap={1.5} mt={1.5} key={index}>
      <img width="80px" height="80px" className="rounded cover" src={item.item?.photo || item.box?.photo} alt={item.item?.name || item.box?.name} />
      <Box flex={1}>
        {item.type === 'Box'
          ? (
            <div className="weight-600">
              {item.box?.name || `Box ${item.box?.digital_box_id}`}
            </div>
          )
          : <div className="weight-600">{item.item?.name}</div>}
        {item.type === 'Box'
          ? (
            <Box>
              <Box>
                {item.box?.amount}
                {' '}
                {t('common.items')}
              </Box>
              <Box>
                {item.box?.dimension}
              </Box>
            </Box>
          ) : (
            <Box display="flex" className="s-10" color="#586479" gap={0.5} flexWrap="wrap" alignItems="center">
              <div>{item.category?.name || '-'}</div>
              <div>
                ・
                {item.condition?.name || '-'}
              </div>
              <div>
                ・
                {item.item?.volume || '0 mL'}
              </div>
            </Box>
          )}
        {!!item.item?.is_sale
            && (
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
              <Box className="s-10 mute weight-600">
                In cellar since 12 Aug 2022
              </Box>
              <Box display="flex" gap={0.5}>
                <img src={Images.Setting} alt="setting-icon" />
              </Box>
            </Box>
            )}
      </Box>
      <Box>
        {items.length > 1
        && (
        <IconButton sx={{ p: 0 }} onClick={() => deleteItem(item.id)}>
          <DeleteOutlineRounded />
        </IconButton>
        )}
        <Box display="flex" gap={0.5} mt={2}>
          <img src={Images.CheckRed} alt="check-icon" />
        </Box>
      </Box>
    </Box>
  ));

  return (
    <>
      <Elements.PageBase navigate={navigate} noNav>
        <Box className={`${classes.root} no-scrollbar`}>
          <Elements.Navigator
            title={t('common.reqOut')}
            onBack={handleShowBackAlert}
            secondaryBtn={(
              <Elements.TooltipBase
                message={headerTooltipMessage}
                open={openTooltip}
                onClick={() => setOpenTooltip(true)}
                onClose={() => setOpenTooltip(false)}
                icon={<InfoOutlined className="black" fontSize="small" />}
              />
            )}
          />
          <Container>
            <Box className="s-14 weight-700" mt={3} mb={1.5}>{t('reqOut.add')}</Box>
            {renderAddress()}
          </Container>
          <Divider sx={{ borderWidth: 4, borderColor: '#F5F6F8', my: 3 }} />
          <Container>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
              <Box className="s-14 weight-700">Item detail</Box>
              {!isBox
              && (
              <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer' }} onClick={() => setOpenAddItems(true)}>
                <AddCircleOutlineRounded sx={{ color: Colors.primary }} fontSize="small" />
                <Box className="s-16 primary-green weight-600">{t('reqOut.addItem')}</Box>
              </Box>
              )}
            </Box>
            {renderSelectedItems(items)}
          </Container>
          <Divider sx={{ borderWidth: 4, borderColor: '#F5F6F8', my: 3 }} />
          <Container>
            <div className="s-14 weight-600 mt-3">
              {t('reqOut.note')}
              <i>
                {' '}
                (
                {t('common.opt')}
                )
              </i>
            </div>
            <TextField
              sx={{ mt: 0.5 }}
              size="small"
              fullWidth
              placeholder="Write here..."
              value={fields.pickup_notes}
              onChange={({ target }) => setFields({ ...fields, pickup_notes: target.value })}
            />
            {isBox
            && (
            <>
              <div className="s-14 weight-600 mt-3">
                {t('reqOut.amount')}
              </div>
              <TextField
                sx={{ mt: 0.5 }}
                size="small"
                fullWidth
                placeholder="Write here..."
                value={fields.pickup_amount}
                onChange={({ target }) => {
                  const newVal = Number(onlyNumbers(target.value));
                  if (newVal <= domLocation.state?.box?.amount && newVal >= 0) {
                    setFields({
                      ...fields,
                      pickup_amount: newVal,
                    });
                  }
                }}
                InputProps={{
                  endAdornment: fields.pickup_amount === domLocation.state?.box?.amount ? `(${t('common.all')})` : `(${t('reqOut.partial')})`,
                }}
              />
            </>
            )}
          </Container>
          <Divider sx={{ borderWidth: 4, borderColor: '#F5F6F8', my: 3 }} />
          <Container>
            <Box className="s-14 weight-600">
              {t('reqOut.method')}
              <span className="primary-green">*</span>
            </Box>
            {fields.delivery?.id
              ? (
                <Box
                  display="flex"
                  gap={1.5}
                  border="1px solid"
                  borderColor="#F5F6F8"
                  borderRadius="8px"
                  p={1.5}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => setOpenSelectDelivery(true)}
                  justifyContent="space-between"
                  mt={0.5}
                >
                  <img alt="delivery" src={Images.IconDelivery} />
                  <Box flex={1}>
                    <Box display="flex" justifyContent="space-between">
                      <Box fontWeight="600" fontSize={12}>{fields.delivery?.name}</Box>
                      <Box color={Colors.primary} fontWeight="700">Free</Box>
                    </Box>
                    <Box fontSize={10} color="#586479" mt={0.5}>
                      {t('reqOut.setTime')}
                    </Box>
                  </Box>
                  <ChevronRightRounded sx={{ alignSelf: 'center', color: '#404852' }} />
                </Box>
              )
              : (
                <TextField
                  sx={{ mt: 0.5 }}
                  size="small"
                  value=""
                  placeholder="Choose request out method"
                  onClick={() => setOpenSelectDelivery(true)}
                  fullWidth
                  InputProps={{
                    endAdornment: <ChevronRightRounded />,
                  }}
                />
              )}
            {fields.delivery?.icon === 'warehouse'
            && (
              <>
                <Box className="s-14 weight-600" mt={3}>
                  {t('reqOut.loc')}
                </Box>
                <Box
                  display="flex"
                  gap={1.5}
                  border="1px solid"
                  borderColor="#F5F6F8"
                  borderRadius="8px"
                  p={1.5}
                  justifyContent="space-between"
                  mt={0.5}
                >
                  <Box flex={1}>
                    <Box display="flex" justifyContent="space-between" color="#404852" fontWeight="600" fontSize={12}>
                      {t('reqOut.oeno')}
                    </Box>
                    <Box fontSize={10} color="#586479" mt={0.5}>
                      240 Boulevard Street, 65008, Paris France
                    </Box>
                  </Box>
                </Box>
              </>
            )}
            <Box className="s-14 weight-600" mt={3}>
              {t('reqOut.setTime2')}
              <span className="primary-green">*</span>
            </Box>
            {fields.pickup_date
              ? (
                <Box
                  display="flex"
                  gap={1.5}
                  border="1px solid"
                  borderColor="#F5F6F8"
                  borderRadius="8px"
                  p={1.5}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => setOpenBookPickup(true)}
                  justifyContent="space-between"
                  mt={0.5}
                >
                  <Box flex={1}>
                    <Box display="flex" justifyContent="space-between" color="#404852" fontWeight="600" fontSize={12}>
                      <Box>{moment(fields.pickup_date).format('DD MMM YYYY')}</Box>
                      <Box>{moment(fields.pickup_date).format('HH.mm')}</Box>
                    </Box>
                    <Box fontSize={10} color="#586479" mt={0.5}>
                      {t('reqOut.reminding')}
                      {' '}
                      {getReminderDesc(fields.reminder)}
                    </Box>
                  </Box>
                  <ChevronRightRounded sx={{ alignSelf: 'center', color: '#404852' }} />
                </Box>
              )
              : (
                <TextField
                  sx={{ mt: 0.5 }}
                  size="small"
                  placeholder="Set schedule"
                  onClick={() => setOpenBookPickup(true)}
                  value={fields.pickup_date ? moment(fields.pickup_date).format('DD MMM YYYY HH.mm') : ''}
                  fullWidth
                  InputProps={{
                    endAdornment: <ChevronRightRounded />,
                  }}
                />
              )}
          </Container>

          <Box position="absolute" bottom={0} left={0} right={0} py={1} bgcolor="white">
            <Container>
              <Box className="s-12">
                {t('common.read')}
                {' '}
                <Link to={ROUTES.termsConditions()} style={{ color: '#38AC3D' }}>{t('common.tor')}</Link>
              </Box>
              <Button
                variant="contained"
                className="btn-contained"
                sx={{ mt: 2 }}
                fullWidth
                onClick={handleRequestOut}
                disabled={isLoading}
                startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)}
              >
                {t('reqOut.proceed')}
              </Button>
            </Container>
          </Box>
        </Box>
      </Elements.PageBase>

      <Elements.PageBase noNav>
        <Elements.Footer />
      </Elements.PageBase>

      <Drawer
        anchor="right"
        open={openChangeAddress}
        onClose={() => setOpenChangeAddress(false)}
      >
        <Elements.Navigator
          title="Change address"
          onBack={() => setOpenChangeAddress(false)}
          secondaryBtn={(
            <IconButton LinkComponent={Link} to={`${ROUTES.address()}/update`}>
              <AddCircleOutlineRounded fontSize="small" className="black" />
            </IconButton>
          )}
        />
        <Box maxWidth="375px" px={2} boxSizing="border-box">
          <AddressBoxes selectAddress={takeAddress} />
        </Box>
      </Drawer>

      <Drawer
        anchor="right"
        open={openAddItems}
        onClose={() => setOpenAddItems(false)}
      >
        <Elements.Navigator
          title="Add item"
          onBack={() => setOpenAddItems(false)}
        />
        <Box maxWidth="375px" px={2} boxSizing="border-box">
          {renderAllItems(box.items)}
        </Box>
      </Drawer>

      <Drawer
        anchor="right"
        open={openBookPickup}
        onClose={() => setOpenBookPickup(false)}
      >
        <Elements.Navigator
          title="Set schedule"
          onBack={() => setOpenBookPickup(false)}
          secondaryBtn={(
            <Elements.TooltipBase
              message="By using booked pick-up service, you can choose to pick up wine anytime and on any date"
              open={openTooltipBookPickup}
              onClick={() => setOpenTooltipBookPickup(true)}
              onClose={() => setOpenTooltipBookPickup(false)}
              icon={<InfoOutlined className="black" fontSize="small" />}
            />
          )}
        />
        <Box minWidth="280px" maxWidth="375px" px={2} boxSizing="border-box">
          <div className="s-14 weight-600 mt-3">
            Choose pick up duration
            <span className="primary-green">*</span>
          </div>
          <DatePicker
            minDate={moment().add(1, 'days').toDate()}
            value={book.pickup_date}
            name="pickup_date"
            onChange={(val) => setBook({ ...book, pickup_date: val })}
            renderInput={(params) => (
              <TextField
                size="small"
                sx={{ mt: 1 }}
                fullWidth
                InputProps={{
                  endAdornment: (<CalendarMonthRounded />),
                }}
                {...params}
              />
            )}
          />
          <div className="s-14 weight-600 mt-3">
            Choose time
            <span className="primary-green">*</span>
          </div>
          <TimePicker
            // minDate={moment().add(1, 'days')}
            value={book.pickup_date}
            onChange={(val) => setBook({ ...book, pickup_date: val })}
            renderInput={(params) => (
              <TextField
                size="small"
                sx={{ mt: 1 }}
                fullWidth
                InputProps={{
                  endAdornment: (<AccessTime />),
                }}
                {...params}
              />
            )}
          />
          <div className="s-14 weight-600 mt-3">
            Reminder
            <span className="primary-green">*</span>
          </div>
          <TextField
            select
            size="small"
            fullWidth
            value={book.reminder}
            onChange={(e) => setBook({ ...book, reminder: e.target.value })}
          >
            {reminders.map((reminder) => (
              <MenuItem value={reminder.minutes} key={reminder.minutes}>{reminder.desc}</MenuItem>
            ))}
          </TextField>

          <Button disabled={!book.reminder} variant="contained" className="btn-contained" fullWidth sx={{ mt: 3 }} onClick={handleSetBookPickup}>Confirm</Button>

        </Box>
      </Drawer>
      <Drawer
        anchor="right"
        open={openSelectDelivery}
        onClose={() => setOpenSelectDelivery(false)}
      >
        <Elements.Navigator
          title="Request Out Method"
          onBack={() => setOpenSelectDelivery(false)}
        />
        <Box minWidth="280px" maxWidth="375px" px={2} py={3} boxSizing="border-box" position="relative">
          <Box fontSize={12} color="#586479">
            You can choose available shipping method below.
            Estimated date arrival will depends on the distance and time duration to your location!
          </Box>

          <Box mt={3} display="flex" flexDirection="column" gap={2}>
            {delivery.map((method) => (
              <Box
                key={method.id}
                display="flex"
                gap={1.5}
                border="1px solid"
                borderColor={selectedDelivery.id === method.id ? Colors.primary : '#F5F6F8'}
                borderRadius="8px"
                p={1.5}
                sx={{ cursor: 'pointer' }}
                onClick={() => setDelivery(method)}
              >
                <img alt="delivery" src={method.icon === 'warehouse' ? Images.IconHome : Images.IconDelivery} />
                <Box flex={1}>
                  <Box display="flex" justifyContent="space-between">
                    <Box fontWeight="600" fontSize={12}>{method.name}</Box>
                    <Box color={Colors.primary} fontWeight="700">{method.price ? `+ ${formatNumToCurrency(method.price)}` : 'Free'}</Box>
                  </Box>
                  <Box fontSize={10} color="#586479" mt={0.5}>
                    {method.description}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>

          <Button
            sx={{ mt: 3 }}
            disabled={deliveryLoading || !selectedDelivery.id}
            variant="contained"
            className="btn-contained"
            fullWidth
            onClick={handleSetDelivery}
          >
            Confirm
          </Button>
        </Box>
      </Drawer>
    </>
  );
}
